<template>
    <div class="loader" :class="{'is-loading': pageIsLoading, 'loader-full-screen': fullScreen}">
        <div class="loading is-loading">
            <div class="mr-re"></div>
            <div class="mr-bil"></div>
            <div class="mr-ly"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'v-loader',
        props: {
            fullScreen: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        computed: {
            pageIsLoading() {
                return this.$someLoading();
            },
        },
        watch: {
            pageIsLoading() {
                // reset position to top of page
                // whenever we load something
                if (this.pageIsLoading) {
                    window.scrollTo(0, 0);
                    document.body.classList.add('no-scroll');
                } else {
                    document.body.classList.remove('no-scroll');
                }
            },
        },
    };
</script>
